import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NOVOLoader from '../../shared/components/NOVOLoader';
import { getFallbackRedirect, getRedirectForAction } from './actionHandlers';
import usePersistDeeplinkData from './hooks/usePersistDeeplinkData';
import usePublicApplicationTypes from './hooks/usePublicApplicationTypes';
import useRouteFallbackRedirect from './hooks/useRouteFallbackRedirect';
import useRouteLanguage from './hooks/useRouteLanguage';
import useRouteProfileSync from './hooks/useRouteProfileSync';
import useRouteQueryParams from './hooks/useRouteQueryParams';

const RouteHandler = ({ location, setHeaderTitle }) => {
  const isAuthenticated = useSelector(
    (state) => !!state.authReducer.auth_token
  );
  const selectedLanguage = useSelector(
    (state) => state.settingsReducer?.selectedLanguage
  );

  const { deeplinkKey, hasDeeplinkParams, queryParams } = useRouteQueryParams(
    location.search
  );
  const appLanguage = useRouteLanguage({
    queryLang: queryParams.lang,
    selectedLanguage,
  });

  const shouldWaitForDeeplinkPersistence = usePersistDeeplinkData({
    deeplinkKey,
    hasDeeplinkParams,
    queryParams,
  });
  const shouldWaitForProfileSync = useRouteProfileSync({
    queryParams,
    setHeaderTitle,
  });
  const shouldWaitForApplicationTypes = usePublicApplicationTypes({
    appLanguage,
    queryParams,
  });

  const redirectComponent = useMemo(
    () => getRedirectForAction({ ...queryParams, isAuthenticated }),
    [queryParams, isAuthenticated]
  );
  const fallbackRedirect = useRouteFallbackRedirect({
    action: queryParams.action,
    redirectComponent,
  });

  if (
    redirectComponent &&
    !shouldWaitForProfileSync &&
    !shouldWaitForDeeplinkPersistence &&
    !shouldWaitForApplicationTypes
  ) {
    return redirectComponent;
  }

  if (fallbackRedirect) {
    return getFallbackRedirect();
  }

  return (
    <div className="flex flex-1 items-center justify-center">
      <NOVOLoader />
    </div>
  );
};

export default withRouter(RouteHandler);
